import { Injectable } from '@angular/core';
import { LocalStorageService } from 'angular-web-storage';
import { LoadingService } from 'src/app/components/loading/loading-service.service';
import { AlertBarService } from '../alert-bar/alert-bar.service';
import { ApiService } from '../api/api.service';
import { SessionService } from '../session/session.service';

@Injectable({
  providedIn: 'root',
})
export class TokenService {
  userData: any = [];
  phone: any;
  cpf!: string;

  constructor(
    private api: ApiService,
    public storage: LocalStorageService,
    public toast: AlertBarService,
    private session: SessionService,
    public loader: LoadingService
  ) {
    /* this.userData = this.session.getUserData()

          if(this.userData && this.userData.CPF){

            this.getToken(this.userData.CPF)
            
          }
          else
          {
            
            this.getToken(this.storage.get('CPF'))
        
          }*/
  }

  getToken(cpf: any, type = 'sms') {
    this.cpf = cpf;

    this.loader.startLoading();
    this.api
      .query(
        'cliente/' +
          cpf +
          '/voucher/app-sabemi-digital?appCode=/e5w87U0gtH&tipoEnvio=' +
          type,
        {},
        'get'
      )
      ?.subscribe(
        (data: any) => {
          if (data.Sucesso) {
            this.phone = data.Phone;
            this.loader.stopLoading();
          } else {
            this.loader.stopLoading();
            this.toast.openAlert('Erro ao enviar código do token', 'error');
          }
        },
        (e) => {
          this.loader.stopLoading();
          this.toast.openAlert('Erro ao enviar código do token', 'error');
        }
      );
  }

  validateToken(
    cpf: string,
    voucher: string,
    cbReturn: (data: any) => void,
    cbError: (e: any) => void
  ) {
    this.api
      .query('cliente/' + cpf + '/voucher/' + voucher + '/validate', {}, 'get')
      ?.subscribe(cbReturn, cbError);
  }

  updatePasswordByVoucher(
    cpf: string,
    voucher: string,
    cbReturn: (data: any) => void,
    cbError: (e: any) => void
  ) {
    this.api
      .query(
        'cliente/senha',
        {
          Request: {
            CPF: cpf,
            Password: voucher,
            Voucher: voucher,
          },
        },
        'post'
      )
      ?.subscribe(cbReturn, cbError);
  }
}
